/* * @Author: jingyu.yang * @Date: 2021-12-17 10:02:49 * @Last Modified by:
jingyu.yang * @Last Modified time: 2022-08-02 14:50:15 */
<template>
  <div :class="{
    ischangearea: isChangeArea,
    packAndChange: isPackUp && isChangeArea,
  }" class="doc">
    <div class="doc-mian">
      <div class="doc-mid">
        <DocMain v-if="current && liveToken" ref="mainRef" :type="0" :current="current" :step="updateStep"
          @showList="listVisible = true" @message="onMessage" />
        <template v-else-if="!loading">
          <Blank v-if="shareType === 4" key="pse" :src="wizhiboDocImg" :width="377" :height="227" />
          <Blank v-else key="doc" :width="isChangeArea ? 90 : 192" :btnText="isChangeArea ? '' : this.$t('doc.添加文档')"
            :text="isChangeArea ? '' : this.$t('doc.也可点击左下角添加文档')" @btnClick="add" />
        </template>
        <div class="doc-fix-bottom" :class="{ 'is-init-pseudo': isInitPseudo }">
          <slot name="bottom" />
        </div>
        <slot />
      </div>
    </div>
    <DocTool :tabs="tabs" :type="0" :docs="docs" :page="page" :scaleText="scaleText" :activeId="activeId"
      :disabled="shareType === 4" @tabDel="tabDel" @add="add" @tabSelect="tabSelect" @scalePlus="setZoomPlus"
      @scaleMinus="setZoomMinus" @setPage="setPage" />
    <DocList ref="listRef" :visible.sync="listVisible" @publish="onPublish" />
  </div>
</template>

<script>
import DocMain from "./doc.vue";
import DocTool from "@/components/doc/doc-tool";
import DocList from "@/components/doc/doc-list";
import Blank from "@/components/blank";
import { mapGetters, mapState } from "vuex";
import { shareFileStart, getShareInfo } from "@/api/docRequest/api";
import { publish, unPublish, resourceList } from "@/api/liveRequest/resource";
import { getParameter } from "@/utils/global";
import { pushRoomMessageFunc } from "@/utils/socketMessageDispose";
import Role from "@/mixins/role";
import wizhiboDocImg from "@/assets/images/blank/weizhibo-doc.png";
import { getPreview } from "@/api/docRequest/api";
import aw from "@/utils/aw";
import Bus from "@/components/doc/bus";

export default {
  name: "Doc",
  components: {
    DocMain,
    DocTool,
    DocList,
    Blank,
  },
  mixins: [Role],
  data() {
    return {
      wizhiboDocImg,
      tabs: [],
      list: [],
      current: undefined,
      roomId: getParameter("roomId"),
      listVisible: false,
      // 是否初次显示伪直播
      isInitPseudo: false,
      // 当前正在共享的
      hostShare: undefined,
      docs: undefined,
      page: undefined,
      scale: 1,
      loading: false,
      viewPage: undefined,
      updateStep: {},
    };
  },
  computed: {
    ...mapState("docInfo", ["docRight"]),
    ...mapGetters([
      "shareType",
      "liveToken",
      "isChangeArea",
      "isPackUp",
      "leftToolType",
      "userInfo",
    ]),
    activeId() {
      return this.current?.transFileId;
    },
    showPse() {
      return this.avctl && this.shareType === 4;
    },
    scaleText() {
      return Math.ceil((this.scale * 100).toFixed(2));
    },
  },
  watch: {
    showPse(n, o) {
      if (!o && n) {
        this.isInitPseudo = true;
        setTimeout(() => {
          this.isInitPseudo = false;
        }, 3000);
      }
    },
    liveToken: {
      immediate: true,
      async handler(n) {
        if (n) {
          await this.getList();
          this.getShareInfo();
        }
      },
    },
    leftToolType() {
      this.$refs.mainRef?.setMessage("update", [2]);
    },
    share(n, o) {
      console.log(n, o, "123")
      if (o === 0 && n === 1) {
        this.$nextTick(() => {
          console.log(this.leftToolType, "leftToolType");
          if (this.leftToolType === 0) {
            console.log(this.current, "current");
            if (this.current?.hostPreview) {
              this.shareFile(this.current, this.page);
            } else {
              this.$refs.mainRef?.setMessage("forceSync");
            }
          }
        });
      } else {
        this.updateStep = {}
      }
    },
  },
  created() {
    pushRoomMessageFunc(({ cmd, requestData }) => {
      switch (cmd) {
        case 7107:
          this.message_7107(requestData);
          break;
        case 7127:
          this.message_7127(requestData);
          break;
      }
    });
    Bus.$on("changeDisturb", this.handleChangeDisturb);
  },
  methods: {
    message_7107(body) {
      if (body.event === "all_doc_share_data") {
        const isNotDisturb = this.$store.state.defaultInfo.isNotDisturb;
        if (this.share === 0 && isNotDisturb === "false" && body.cmd !== 3071) return;
        this.message_7107_doc(body);
      }
    },
    // 处理文档消息
    message_7107_doc(body) {
      if (!this.current?.hostPreview) {
        this.$refs.mainRef?.setMessage("setNotice", body);
      }
      switch (body.cmd) {
        case 3071:
          if (this.current?.transFileId === body.fileId && this.share) {
            this.hostShare = body;
            this.current.hostPreview = false;
            this.current.shareId = body.shareId;
            this.current.transFileId = body.fileId;
            setTimeout(() => {
              this.setPage(this.page);
            }, 1000);
            return;
          }
          body.transFileId = body.fileId;
          this.current = body;
          this.hostShare = body;
          this.tabs.map((item) => {
            if (item.transFileId === body.fileId) {
              item.shareId = body.shareId;
            }
          });
          break;
        case 3072:
          this.current = null;
          this.hostShare = null;
          this.docs = null;
          break;
        case 3076:
          if (!this.share) {
            if (this.current?.hostPreview && this.hostShare) {
              this.current = this.hostShare;
            }
            this.$store.commit("SET_LEFTTOOLTYPE", 0);
            this.updateStep = {}
            console.log("body.content.from_page < body.content.to_page", body.content.from_page, body.content.to_page, this.page);
            var page = this.page
            setTimeout(() => {
              var from_page = parseInt(body.content.from_page)
              var to_page = parseInt(body.content.to_page)
              const boo = body.content && (from_page < to_page && page > to_page && page != from_page)
              console.log("[[[[[[[aniStep]]]]]]]", "aniStep11111", from_page, to_page, this.page, boo, from_page < to_page, page > to_page, page != from_page);
              if (boo) {
                console.log("[[[[[[[aniStep]]]]]]]", "aniStep");
                this.$refs.mainRef?.setMessage("aniStep", {
                  page: body.page,
                  isNext: true,
                  index: 0,
                  aniLast: true,
                });
              }
            }, 10)
          }
          break;
        case 3079:
          // this.getList();
          break;
        case 3082:
          if (!this.share) {
            // if(this.page !== body.page){
            //   this.setPage(this.page);
            // }
            // this.$refs.mainRef?.setMessage("aniStep", {
            //   page: body.page,
            //   index: parseInt(body.step),
            //   aniLast: true,
            // });
          }
          break;
      }
    },
    message_7127(body) {
      console.log("doc control.....")
      switch (body.event) {
        case "assistant_webcast_stream_status":
          if (body.opType !== 3) {
            return;
          }
          console.log('return doc control.....')
          if ([1, 2].includes(body.streamStatus)) {
            this.docs = null;
            this.current = null;
            this.hostShare = null;
            this.getList();
            this.getShareInfo();
          }
          break;
        case "doc_publish":
        case "doc_cancel_publish":
          this.getList();
          break;
      }
    },
    onMessage(data) {
      if (data.key === "1") return;
      switch (data.event) {
        case "ready":
        case "update:doc":
          this.docs = data.data;
          break;
        case "update:page":
          this.page = data.data;
          //this.updateStep = { page: data.data, step: 0, lastAni: false };
          break;
        case "update:scale":
          this.scale = data.data;
          break;
        case "update:step":
          this.updateStep = data.data;
          console.log('this.updateStep', data);
          //this.updateStep.lastAni = true;
          break;
      }
    },
    setZoomPlus() {
      this.$refs.mainRef?.setMessage("setZoomPlus");
    },
    setZoomMinus() {
      this.$refs.mainRef?.setMessage("setZoomMinus");
    },
    setPage(page) {
      this.$refs.mainRef?.setMessage("slideTo", page);
    },
    setAniStep() {
      this.$refs.mainRef?.setMessage("aniStep", {
        page: this.updateStep.page,
        index: this.updateStep.step,
        aniLast: this.updateStep.aniLast,
      });
    },
    handleDocToolMounted() {
      console.log("doc tool mounted");
    },
    // 添加文档
    add() {
      this.listVisible = true;
    },
    // TODO: 取消共享+取消发布
    async tabDel(item) {
      let next = null;
      const index = this.tabs.findIndex(
        (v) => v.transFileId === item.transFileId
      );
      if (index < 0) {
        return;
      }
      next = this.tabs[index + 1] || this.tabs[index + -1];
      if (item.transFileId === this.hostShare?.transFileId) {
        const [err] = await aw(this.endShare(), "status");
        if (err !== null) return;
        if (next) {
          this.startShare(next);
        } else {
          this.docs = null;
          this.current = null;
          this.hostShare = null;
        }
      }

      this.unPublish(item);
      // if(item.shareId !== this.current.shareId){
      //   this.endOtherShare(item); //关闭非当前文档
      // }
    },
    async unPublish(item) {
      const [err] = await aw(unPublish(item.srcFileId), "code");
      if (err !== null) return;
      this.tabs = this.tabs.filter((v) => v.transFileId !== item.transFileId);
    },
    // 选择文档进行共享
    tabSelect(item) {
      console.log(this.current, "current")
      if (this.current && this.current.transFileId === item.transFileId) return;
      //const isNotDisturb = this.$store.state.defaultInfo.isNotDisturb;
      // if (this.share === 0 && isNotDisturb === "false") return;
      this.shareFile(item);
    },
    async onPublish(item, cb) {
      const close = cb();
      const [err] = await aw(publish(item.srcFileId), "code");
      close();
      if (err !== null) {
        return;
      }
      this.listVisible = false;
      this.tabSelect(item);
      this.getList();
    },
    // TODO: cv_live 获取已发布文档列表
    async getList() {
      if (this.loading) return;
      if (this.tabs?.length) {
        this.loading = true;
      }
      const [err, { data }] = await aw(resourceList(0), "code");
      console.log("获取已发布的文档", data);
      this.loading = false;
      if (err !== null) return;
      const trans = (v) => {
        return {
          ...v,
          ...v.resource,
          name: v.resource.filename,
        };
      };

      this.tabs = data.results
        .filter((v) => v.publish === 1 && v.resource?.fileId)
        .map((v) => trans(v));

      try {
        this.tabs = this.tabs.sort(
          (a, b) => new Date(a.publishTime) - new Date(b.publishTime)
        );
        //console.log(this.tabs,'2222222222222222222')
      } catch (error) {
        console.log(error);
      }
    },
    handleChangeDisturb() {
      this.getShareInfo();
    },
    // 获取共享文档信息
    async getShareInfo() {
      const [err, { data }] = await aw(getShareInfo(this.roomId), "status");
      if (err !== null) return;
      if (data.status === 1) {
        data.transFileId = data.fileId;
        this.current = data;
        this.hostShare = data;
        let findIndex = this.tabs.findIndex((info) => {
          return info.transFileId == data.transFileId;
        });
        if (findIndex == -1) {
          this.tabs.unshift({
            transFileId: data.transFileId,
            name: data.fileTitle,
          });
        }
      }
    },
    // 共享文件
    async shareFile(row) {
      if (!this.share) {
        const [err, { data }] = await aw(getPreview(row.transFileId), "status");
        if (err !== null) return;
        const view = JSON.parse(JSON.stringify(row));
        view.viewUrl = data;
        view.hostPreview = true;
        this.current = view;
        return;
      }
      this.startShare(row);
    },
    // 开始共享
    async startShare({ transFileId, filename, shareId }) {
      let params = {
        cmd: 3001,
        fileId: transFileId,
        fileTitle: filename,
        roomId: this.roomId,
        shareId: shareId,
      };
      await aw(shareFileStart(params), "status");
    },
    // 结束共享
    endShare() {
      let params = {
        cmd: 3002,
        shareId: this.hostShare.shareId,
      };
      return shareFileStart(params);
    },
    endOtherShare({ shareId }) {
      let params = {
        cmd: 3013,
        shareId: shareId,
        roomId: this.roomId,
      };
      return shareFileStart(params);
    },
  },
};
</script>

<style lang="scss" scoped>
.doc {
  height: 100%;
  padding-bottom: 30px;
  background-color: #131625;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.doc-mian {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.doc-mid {
  position: relative;
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.doc-fix-bottom {
  position: absolute;
  bottom: 0;
  width: 100%;
  transform: translateY(calc(100% + 10px));
  transition: all 0.3s ease-in-out;
  transition-delay: 0.3s;
}

.doc-mian:hover {
  .doc-fix-bottom {
    transform: translateY(0);
  }
}

.is-init-pseudo {
  transform: translateY(0);
}

.ischangearea {
  .doc-mian {
    position: absolute;
    top: 0;
    right: -291px;
    width: 280px;
    height: 158px;
    background-color: #131625;
    z-index: 999;
  }
}

.isPackUp {
  .ischangearea {
    .doc-mian {
      display: none;
    }
  }
}

.packAndChange {
  .doc-mid {
    display: none;
  }
}
</style>
